<template>
	<div v-if="projectDetail">
		<v-subheader class="v-subheader">
			<v-layout>
				<v-icon class="text--secondary ma-1">device_hub</v-icon>
				<h1 class="text--secondary text-uppercase">{{ projectDetail.name }}</h1>
			</v-layout>
		</v-subheader>
		<v-layout class="ma-5 align-center justify-center">
			<v-container grid-list-md text-xs-center class="container">
				<v-layout row wrap>
					<v-flex md3 xs12>
						<v-card class="tab-card listbox">
							<v-list dense>
								<v-list-item
										v-for="item in items"
										:key="item.title"
										:class="active === item.key ? 'active' : ''"
										@click="active = item.key">
									<v-list-item-action>
										<v-icon v-if="item.icon" color="grey">{{ item.icon }}</v-icon>
									</v-list-item-action>

									<v-list-item-content>
										<v-list-item-title v-text="item.title"></v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-card>
					</v-flex>
					<v-flex md9 xs12>
						<v-card class="tab-card" v-if="active === 'main'">
							<general-form @save="saveProject"></general-form>
						</v-card>
						<v-card class="tab-card" v-if="active === 'routes' ">
							<route-list></route-list>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</v-layout>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import GeneralForm from './general-form';
import RouteList from '../routes/route-list';

export default {
	name: 'ProjectsList',
	components: { RouteList, GeneralForm },
	data() {
		return {
			active: 'main',
		};
	},
	computed: {
		...mapState({
			projectDetail: state => state.project.projectDetail,
		}),

		items() {
			return [
				{ key: 'main', icon: 'fingerprint', title: this.$t('project-detail.menu.general-settings') },
				{ key: 'routes', icon: 'call_split', title: this.$t('project-detail.menu.routes') },
			];
		}
	},
	mounted() {
		this.getAllRoles();
		if (this.$route.params.id !== 'new') {
			this.getProject(this.$route.params.id);
		} else {
			this.addProject();
		}
	},
	methods: {
		...mapActions({
			getProject: 'project/getProjectById',
			saveProject: 'project/saveProject',
			addProject: 'project/setNewProject',
			getAllRoles: 'role/getAllRoles',
		}),
	},
};
</script>

<style lang="scss" scoped>
@import "@/styles/colors";

.v-subheader {
	min-height: 100px;
	padding: 20px;
	background-color: $light-grey;
}

.container {
	max-width: 100% !important;
	padding: 5px;
}

.tab-card {
	margin-right: 5px;
	padding: 10px !important;
	border-radius: 7px !important;

	&.listbox {
		padding: 10px 0 !important;
	}

	.active {
		border-left: $dark-blue 3px solid;
		background-color: rgba(152, 144, 146, 0.2);

		i {
			color: $dark-blue !important;
		}
	}

	.v-list__item__action {
		width: 25px;
		min-width: 30px;
		font-weight: 500;
	}
}
</style>
